const LOGO = "https://customer-assets-v7afamib.emergentagent.net/job_archi-interior-hub/artifacts/jmvnezz2_image.png";
const FONTS = "https://fonts.googleapis.com/css2?family=Manrope:wght@400;600;700;800&family=IBM+Plex+Sans:wght@400;500;600&display=swap";

const esc = (s) => String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
const money = (v) => "$" + Number(v || 0).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

function projectNumber(project) {
  if (project.number) return project.number;
  const m = String(project.name || "").match(/^\s*(\d{6})/);
  return m ? m[1] : "";
}

// Opens a print-friendly window (browser Save as PDF). kind: "material" | "ffe".
export function printSchedule({ project, kind, items, meta, user, copy = "client", images = true, issuedFor = "Client approval" }) {
  const isFfe = kind === "ffe";
  const withPrices = isFfe && copy === "builder";
  const title = isFfe ? "FF&E Schedule" : "Material Schedule";
  const rev = (meta && meta.rev) || "A";
  const today = new Date().toLocaleDateString("en-AU", { day: "2-digit", month: "short", year: "numeric" });

  const groups = {};
  items.forEach((i) => (groups[i.group || "—"] = groups[i.group || "—"] || []).push(i));

  let subtotal = 0;
  items.forEach((i) => { subtotal += (i.rate_ex_gst || 0) * (i.qty || 0); });
  const gst = subtotal * 0.1;

  const cols = ["Code", "Item", "Location", "Finish / colour", "Size", "Qty", "Unit"];
  if (withPrices) cols.push("Rate ex GST", "Total");
  const headCells = cols.map((c) => `<th>${esc(c)}</th>`).join("");

  const body = Object.keys(groups).map((g) => {
    let grpTotal = 0;
    const rows = groups[g].map((i) => {
      const img = images && (i.images || [])[0]
        ? `<img class="thumb" src="${process.env.REACT_APP_BACKEND_URL}/api/files/${esc(i.images[0].path)}" />` : "";
      const line = (i.rate_ex_gst || 0) * (i.qty || 0);
      grpTotal += line;
      let tds = `<td class="code">${esc(i.code)}</td>
        <td class="item">${img}<div><div class="nm">${esc(i.name)}</div><div class="sub">${esc([i.supplier, i.product_code].filter(Boolean).join(" · "))}</div></div></td>
        <td>${esc(i.location)}</td><td>${esc(i.finish)}</td><td>${esc(i.size)}</td>
        <td>${esc(i.qty)}</td><td>${esc(i.unit)}</td>`;
      if (withPrices) tds += `<td>${money(i.rate_ex_gst)}</td><td>${money(line)}</td>`;
      return `<tr>${tds}</tr>`;
    }).join("");
    const grpSub = withPrices
      ? `<tr class="grpsub"><td colspan="7"></td><td class="tl">${esc(g)} subtotal</td><td>${money(grpTotal)}</td></tr>`
      : "";
    return `<tr class="grp"><td colspan="${cols.length}">${esc(g)} <span>${groups[g].length} item${groups[g].length !== 1 ? "s" : ""}</span></td></tr>${rows}${grpSub}`;
  }).join("");

  const footTotals = withPrices ? `<tfoot><tr><td colspan="7"></td><td class="tl">Subtotal ex GST</td><td>${money(subtotal)}</td></tr>
    <tr><td colspan="7"></td><td class="tl">GST 10%</td><td>${money(gst)}</td></tr>
    <tr><td colspan="7"></td><td class="tl"><strong>Total inc GST</strong></td><td><strong>${money(subtotal + gst)}</strong></td></tr></tfoot>` : "";

  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${esc(title)} — ${esc(project.name)}</title>
  <link rel="stylesheet" href="${FONTS}">
  <style>
    @page { size: A4 landscape; margin: 12mm; }
    * { box-sizing: border-box; }
    body { font-family:'IBM Plex Sans',sans-serif; color:#18181b; margin:0; }
    .head { display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:14px; }
    .head img { height:40px; }
    .brand { font-family:'Manrope',sans-serif; font-weight:700; font-size:13px; margin-top:4px; }
    .ttl { font-family:'Manrope',sans-serif; font-size:28px; font-weight:800; letter-spacing:-0.02em; margin:2px 0; }
    .pn { font-size:12px; color:#52525b; }
    .meta { text-align:right; font-size:11px; color:#52525b; line-height:1.6; }
    table { width:100%; border-collapse:collapse; font-size:11px; }
    thead th { text-align:left; font-size:9px; text-transform:uppercase; letter-spacing:.12em; color:#52525b; padding:7px 8px; border-bottom:2px solid #18181B; }
    td { padding:7px 8px; border-bottom:1px solid #f0f0f0; vertical-align:top; }
    tr.grp td { background:#f4f4f5; font-weight:700; font-size:10px; text-transform:uppercase; letter-spacing:.08em; padding:6px 8px; }
    tr.grp span { opacity:.6; margin-left:4px; }
    tr.grpsub td { background:#fafafa; font-size:10px; border-bottom:1px solid #e4e4e7; padding:5px 8px; }
    tr.grpsub .tl { font-weight:600; color:#3f3f46; }
    .code { font-weight:700; }
    .item { display:flex; gap:8px; align-items:flex-start; }
    .thumb { width:40px; height:40px; object-fit:cover; border:1px solid #e4e4e7; border-radius:2px; }
    .nm { font-weight:600; } .sub { color:#71717a; font-size:10px; }
    .tl { text-align:right; color:#52525b; }
    tfoot td { border-bottom:none; padding-top:6px; }
    thead { display:table-header-group; }
    .foot { position:fixed; bottom:4mm; left:0; right:0; font-size:9px; color:#a1a1aa; text-align:center; }
    .disc { font-size:9px; color:#71717a; margin-top:14px; border-top:1px solid #e4e4e7; padding-top:8px; }
  </style></head><body>
    <div class="head">
      <div><img src="${LOGO}" /><div class="brand">The White Project Co</div>
        <div class="ttl">${esc(title)}</div><div class="pn">${esc(project.name)}</div></div>
      <div class="meta">
        <div>Project no. ${esc(projectNumber(project))}</div>
        <div>Revision ${esc(rev)} · ${esc(today)}</div>
        <div>Issued for: ${esc(issuedFor)}</div>
        <div>Prepared by: ${esc((user && user.name) || "")}</div>
        <div>Copy: ${withPrices ? "Builder" : "Client"}</div>
      </div>
    </div>
    <table><thead><tr>${headCells}</tr></thead><tbody>${body || `<tr><td colspan="${cols.length}" style="color:#a1a1aa;padding:16px">No items.</td></tr>`}</tbody>${footTotals}</table>
    <p class="disc">Codes correspond to the TWP co interior drawing set. Quantities are indicative only; confirm on site before ordering. Colours are indicative; refer to physical samples.</p>
    <div class="foot">The White Project Co Pty Ltd · ${esc(title)} · Rev ${esc(rev)}</div>
  </body></html>`;

  const blob = new Blob([html], { type: "text/html" });
  const url = URL.createObjectURL(blob);
  const w = window.open(url, "_blank");
  if (!w) { URL.revokeObjectURL(url); return false; }
  w.addEventListener("load", () => {
    w.focus();
    setTimeout(() => { try { w.print(); } catch (e) { console.error(e); } URL.revokeObjectURL(url); }, 400);
  });
  return true;
}
